import { render, staticRenderFns } from "./OfferCreate.vue?vue&type=template&id=53afdffa"
import script from "./OfferCreate.vue?vue&type=script&lang=ts"
export * from "./OfferCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports